import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { useContentObjectType, getListingAppUrl } from 'content-management-data-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getGenericErrorMessageType = ({
  statusCode
}) => {
  switch (statusCode) {
    case 404:
      return 'notFound';
    case 500:
      return 'badRequest';
    default:
      return null;
  }
};
const ErrorBody = ({
  errorMessage,
  children
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: errorMessage
    }), children]
  });
};
const ErrorPage = ({
  category,
  subCategory,
  statusCode
}) => {
  const {
    contentObjectTypeSingularNoun,
    contentObjectTypePluralNoun,
    contentObjectType
  } = useContentObjectType();
  const errorMessageType = getGenericErrorMessageType({
    statusCode
  });
  const dashboardLink = /*#__PURE__*/_jsx(Link, {
    href: getListingAppUrl({
      contentObjectType
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "content-management-details-lib.backToDashboardLink",
      options: {
        contentObjectTypePluralNoun
      }
    })
  });
  if (errorMessageType) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: errorMessageType,
      children: /*#__PURE__*/_jsx(ErrorBody, {
        errorMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `content-management-details-lib.errorPages.${errorMessageType}`
        }),
        children: dashboardLink
      })
    });
  }
  if (category === 'MISSING_PERMISSIONS' && subCategory === 'CMPObjectError.PERMISSIONS_RESTRICTED') {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      illustration: "keys",
      title: I18n.text('content-management-details-lib.errorPages.notPermissioned.title', {
        contentObjectTypeSingularNoun
      }),
      children: /*#__PURE__*/_jsx(ErrorBody, {
        errorMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-details-lib.errorPages.notPermissioned.nextStep"
        }),
        children: dashboardLink
      })
    });
  }
  if (category === 'MISSING_SCOPES' && subCategory === 'CMPObjectError.SCOPE_RESTRICTED') {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: "403",
      children: /*#__PURE__*/_jsx(ErrorBody, {
        errorMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-details-lib.errorPages.notAuthorized",
          options: {
            contentObjectTypePluralNoun
          }
        }),
        children: dashboardLink
      })
    });
  }
  return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "notFound",
    children: /*#__PURE__*/_jsx(ErrorBody, {
      errorMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "content-management-details-lib.errorPages.notFound"
      }),
      children: dashboardLink
    })
  });
};
export default ErrorPage;